/** Shown before payment when the security deposit hold needs a credit card. */
export const CREDIT_CARD_NOTICE =
  "The security deposit requires a credit card. Debit and prepaid cards can't be used for the deposit.";

/**
 * Part of what the renter accepts with the deposit consent (FLEE-412): the
 * hold is renewed automatically before it lapses. Keep it short and plain.
 */
export const HOLD_RENEWAL_NOTICE =
  "A card hold lasts about 7 days. While your rental lasts, the hold may be renewed automatically on the same card until the deposit is released.";

/** The renewal sentence for modes that place a card hold, otherwise null. */
export const holdRenewalNoticeFor = (mode: string): string | null =>
  mode === "after_checkout" || mode === "at_checkin"
    ? HOLD_RENEWAL_NOTICE
    : null;
